import { useTranslations } from "@jugl-web/utils";
import React, { ReactNode } from "react";
import { WebChatBotAccountCard } from "../../../../components/WebChatBotAccountCard/WebChatBotAccountCard";
import { CRMInfoSection } from "../../../../components/CRMInfoSection";
import { ReactComponent as BusinessIcon } from "./assets/business.svg";
import { ReactComponent as PaintIcon } from "./assets/paint.svg";

export const GeneralInfoTabContent: React.FC = () => {
  const { t } = useTranslations();

  return (
    <div className="bg-grey-100 animate-fade-in flex flex-col gap-8 p-8">
      <WebChatBotAccountCard />
      <CRMInfoSection
        title={t({
          id: "client-support-page.account-info",
          defaultMessage: "Account info:",
        })}
        subtitle={t({
          id: "client-support-page.take-care-following-items-to-account-work",
          defaultMessage:
            "Take care of following items to make your Account work",
        })}
        items={[
          {
            title: t({
              id: "client-support-page.set-chat-appearance",
              defaultMessage: "Set Chat Appearance",
            }),
            icon: <PaintIcon />,
            description: t(
              {
                id: "client-support-page.set-chat-appearance-description",
                defaultMessage:
                  "Customize the <b>appearance of messenger</b> to match your website or app. Define, how your customers will see it",
              },
              {
                b: (text: ReactNode) => (
                  <span className="text-primary-800 font-medium">{text}</span>
                ),
              }
            ),
          },
          {
            title: t({
              id: "client-support-page.install-web-chat",
              defaultMessage: "Install Web Chat",
            }),
            icon: <BusinessIcon />,
            description: t(
              {
                id: "client-support-page.install-web-chat-description",
                defaultMessage:
                  "To initialize Web Chat, copy and paste the <b>unique code snippet</b> on every page of your website or app, where you want the messenger to appear",
              },
              {
                b: (text: ReactNode) => (
                  <span className="text-primary-800 font-medium">{text}</span>
                ),
              }
            ),
          },
        ]}
      />
      <CRMInfoSection
        title={t({
          id: "client-support-page.tools-and-tips",
          defaultMessage: "Tools & Tips",
        })}
        subtitle={t({
          id: "client-support-page.everything-you-need-to-know",
          defaultMessage: "Everything you need to know:",
        })}
        items={[
          {
            tips: [
              t({
                id: "client-support-page.web-chat-messages-inbox",
                defaultMessage:
                  "All messages from Web Chat will appear in the Workspace Inbox",
              }),
              t({
                id: "client-support-page.web-chat-repaste-snippet",
                defaultMessage:
                  "After updating the chat launcher settings, re-paste the installation code snippet on your website",
              }),
              t({
                id: "client-support-page.web-chat-disable-remove-snippet",
                defaultMessage:
                  "To disable Web Chat, remove the code snippet that was added before the </body> tag on your website",
              }),
            ],
          },
        ]}
      />
    </div>
  );
};
